// Shared byte-for-byte with MYKYC_API/myKyc_adverse_media_limits.cjs.
const DEFAULT_ADVERSE_LIMITS = { resultsPerQuery: 10, articlesPerSubject: 20 };
const ADVERSE_LIMIT_BOUNDS = { resultsPerQuery: [1, 10], articlesPerSubject: [1, 50] };
function validAdverseLimit(key, value) {
  const [min, max] = ADVERSE_LIMIT_BOUNDS[key];
  return value !== '' && value != null && typeof value !== 'boolean'
    && Number.isInteger(Number(value)) && Number(value) >= min && Number(value) <= max;
}
function normalizeAdverseLimits(settings = {}) {
  return Object.fromEntries(Object.keys(DEFAULT_ADVERSE_LIMITS).map(key => [key,
    validAdverseLimit(key, settings?.[key]) ? Number(settings[key]) : DEFAULT_ADVERSE_LIMITS[key]]));
}
module.exports = { DEFAULT_ADVERSE_LIMITS, ADVERSE_LIMIT_BOUNDS, validAdverseLimit, normalizeAdverseLimits };
